import { useCallback } from 'react';

type EditEventType =
  | 'confirm_entity'
  | 'accept_section'
  | 'structural_edit_move'
  | 'structural_edit_merge'
  | 'structural_edit_delete'
  | 'free_text_override';

export function useEditTelemetry(encounterId: string) {
  const send = useCallback(async (type: EditEventType, section: string, extras: Record<string, unknown> = {}) => {
    try {
      const token = localStorage.getItem('accessToken');
      const headers: Record<string, string> = { 'Content-Type': 'application/json' };
      if (token) {
        headers['Authorization'] = `Bearer ${token}`;
      }
      await fetch(`${import.meta.env.VITE_API_URL}/api/v1/telemetry/edit-events`, {
        method: 'POST',
        headers,
        body: JSON.stringify({
          encounterId,
          type,
          section,
          timestamp: new Date().toISOString(),
          ...extras,
        }),
      });
    } catch (e) {
      // Telemetry failures must never break the UX
      console.warn('edit telemetry failed', e);
    }
  }, [encounterId]);

  return {
    recordConfirm: (section: string, entityRef: string) => send('confirm_entity', section, { entityRef }),
    recordAcceptSection: (section: string) => send('accept_section', section),
    recordStructuralMove: (section: string, entityRef: string, targetSection: string) =>
      send('structural_edit_move', section, { entityRef, targetSection }),
    recordStructuralDelete: (section: string, entityRef: string) =>
      send('structural_edit_delete', section, { entityRef }),
    recordFreeTextOverride: (section: string) => send('free_text_override', section),
  };
}
